import {
  FETCH_SUB_CATEGORIES_REQUEST,
  FETCH_SUB_CATEGORIES_SUCCESS,
  FETCH_SUB_CATEGORIES_FAILURE,
  ADD_SUB_CATEGORY_REQUEST,
  ADD_SUB_CATEGORY_SUCCESS,
  ADD_SUB_CATEGORY_FAILURE,
  UPDATE_SUB_CATEGORY_REQUEST,
  UPDATE_SUB_CATEGORY_SUCCESS,
  UPDATE_SUB_CATEGORY_FAILURE,
  DELETE_SUB_CATEGORY_REQUEST,
  DELETE_SUB_CATEGORY_SUCCESS,
  DELETE_SUB_CATEGORY_FAILURE,
  SET_SUB_CATEGORY_EDIT,
  CLEAR_SUB_CATEGORY_EDIT,
} from '../../../../types/masters/styles/subCategory/subCategoryTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingSubCategory: null,
};

const subCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUB_CATEGORIES_REQUEST:
    case ADD_SUB_CATEGORY_REQUEST:
    case UPDATE_SUB_CATEGORY_REQUEST:
    case DELETE_SUB_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SUB_CATEGORIES_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_SUB_CATEGORY_SUCCESS:
    case UPDATE_SUB_CATEGORY_SUCCESS:
    case DELETE_SUB_CATEGORY_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_SUB_CATEGORIES_FAILURE:
    case ADD_SUB_CATEGORY_FAILURE:
    case UPDATE_SUB_CATEGORY_FAILURE:
    case DELETE_SUB_CATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_SUB_CATEGORY_EDIT:
      return { ...state, editingSubCategory: action.payload };
    case CLEAR_SUB_CATEGORY_EDIT:
      return { ...state, editingSubCategory: null };
    default:
      return state;
  }
};

export default subCategoryReducer; 